module.exports = __webpack_public_path__ + "static/media/local.a97c14de.svg";